<template>
   <b-card v-if="!noBusinessComponent" style="margin-bottom: 2rem">
      <div class="d-flex align-items-center justify-content-between">
         <h2 class="mb-0">Contract Research</h2>

         <div class="d-flex align-items-center">
            <span id="contractor-status" class="mr-2">{{ contractorStatus }}</span>
            <b-button
               id="btn-contractors"
               variant="primary"
               :to="{name: 'contractors-table-staff', params: {id: $companyId}}"
            >
               View
            </b-button>
         </div>
      </div>
   </b-card>

   <CollapseCard v-else title="Contract Research" ident="contract-research">
      <template #subtitle>
         <span class="text-danger"> Not Configured </span>
      </template>
      <b-alert :show="true" variant="primary" class="m-3">
         <p>Contract research have not been fully configured.</p>
         <p class="mb-0">
            <b> This company has no R&D business components associated with an open study. </b>
         </p>
      </b-alert>
   </CollapseCard>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
   props: {
      noBusinessComponent: {
         type: Boolean,
      },
   },

   computed: {
      ...mapGetters({
         isComplete: 'contractors/isComplete',
         company: 'companies/currentCompany',
         activeStudy: 'companies/activeStudy',
      }),

      /** Status of the contractor section */
      contractorStatus() {
         switch (this.isUsingContractors) {
            case true:
               return 'Used Contract Research';
            case false:
               return 'No Contract Research';
            default:
               return 'No Declaration';
         }
      },

      isUsingContractors() {
         if (!this.company) {
            return null;
         }
         const study = this.company.studies.find((study) => study.id == this.activeStudy.id);
         if (study) {
            return study.contractors.wasUsed;
         }
         return null;
      },
   },
};
</script>
